import Vue from 'vue';
import App from './App.vue';
import VueResource from 'vue-resource'; // For the sake of HttpRequests
import vueRouter from 'vue-router';
import Routes from './routes';
import VueStringFilter from 'vue-string-filter'
import Pagination from 'vue-pagination-2';
Vue.use(VueStringFilter)
Vue.component('pagination', Pagination);

Vue.use(VueResource);
Vue.use(vueRouter);

// Create a new instance of our router
const router = new vueRouter({
  routes: Routes,
  mode:'history'
});

Vue.config.productionTip = false

export const bus_events = new Vue();

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
